import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66b3b19c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "重置密码", -1))
const _hoisted_2 = { class: "reg" }

import { reactive, Ref, ref, onMounted } from 'vue'
  import type { FormInstance } from 'element-plus'
  import api from '@/api/index'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'forget',
  emits: ['change'],
  setup(__props, { emit }) {

  const ruleFormRef = ref<FormInstance>()
  const codeImg = ref(null) // 图片验证码

  // 密码验证
  const validatePassword = (rule: any, value: any, callback: any) => {
    if (value.length < 6 || value.length > 20) {
      callback(new Error('请输入6~20密码'))
    } else {
      if (ruleForm.checkPassword !== '') {
        if (!ruleFormRef.value) {
          callback()
          return
        }
        ruleFormRef.value.validateField('checkPassword', () => null)
      }
      callback()
    }
  }

  // 两次密码是否一致验证
  const validateCheckPassword = (rule: any, value: any, callback: any) => {
    if (value == '') {
      callback(new Error('请再次输入密码'))
    } else if (value != ruleForm.password) {
      callback(new Error('两次密码输入不一致'))
    } else {
      callback()
    }
  }

  // 用户名验证
  const validateUsername = (rule: any, value: any, callback: any) => {
    if (value == '') {
      callback(new Error('请输入用户名'))
    } else {
      callback()
    }
  }

  // 手机号验证
  const validatePhone = (rule: any, value: any, callback: any) => {
    const reg = /^[1][3,4,5,7,8][0-9]{9}$/
    if (!reg.test(value)) {
      callback(new Error('手机号码格式错误'))
    } else {
      callback()
    }
  }

  // 表单项
  const ruleForm = reactive({
    username: '',
    password: '',
    phone: '',
    checkPassword: '',
    captcha: '',
    requestCode: '',
  })

  // 表单校验
  const rules = reactive({
    username: [{ validator: validateUsername, trigger: 'blur' }],
    password: [{ validator: validatePassword, trigger: 'blur' }],
    checkPassword: [{ validator: validateCheckPassword, trigger: 'blur' }],
    phone: [{ validator: validatePhone, trigger: 'blur' }],
  })

  // 获取验证码
  const getCaptcha = async () => {
    const requestCode = Date.now()
    ruleForm.requestCode = requestCode.toString()
    const res = await api.captcha({ requestCode })
    codeImg.value = res
  }

  onMounted(() => {
    getCaptcha()
  })

  // 修改密码提交
  const handleEdit = async () => {
    // 表单必填项校验
    const validate = await new Promise(resolve => {
      ruleFormRef.value.validate(val => resolve(val))
    })
    if (!validate) return
    const res = await api.modifyPassword(ruleForm)
    emit('change', 'login')
  }

  // 登录
  
  const handleRegister = (type: string) => {
    emit('change', type)
  }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_el_form, {
      ref_key: "ruleFormRef",
      ref: ruleFormRef,
      model: ruleForm,
      "status-icon": "",
      rules: rules,
      "label-width": "0px",
      class: "demo-ruleForm"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "",
          prop: "username"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: ruleForm.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.username) = $event)),
              type: "text",
              placeholder: "请输入用户名",
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "",
          prop: "phone"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: ruleForm.phone,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.phone) = $event)),
              type: "text",
              placeholder: "请输入注册时的11位手机号",
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "",
          prop: "password"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: ruleForm.password,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ruleForm.password) = $event)),
              type: "password",
              placeholder: "请输入6~20位新密码",
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "",
          prop: "checkPassword"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: ruleForm.checkPassword,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ruleForm.checkPassword) = $event)),
              type: "password",
              placeholder: "请再次输入新密码",
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "",
          prop: "captcha",
          style: {"display":"flex"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: ruleForm.captcha,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ruleForm.captcha) = $event)),
              placeholder: "请输入验证码",
              style: {"flex":"1"},
              clearable: ""
            }, null, 8, ["modelValue"]),
            _withDirectives(_createElementVNode("span", {
              class: "code-img",
              onClick: getCaptcha
            }, null, 512), [
              [_directive_dompurify_html, codeImg.value]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode(_component_el_button, {
      type: "primary",
      class: "login-btn",
      onClick: handleEdit
    }, {
      default: _withCtx(() => [
        _createTextVNode("提 交")
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        onClick: _cache[5] || (_cache[5] = ($event: any) => (handleRegister('login')))
      }, "登录")
    ])
  ], 64))
}
}

})